import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Api } from '../api';
// import { AppSettingService } from '../services/app.settings';

@Injectable()
export class CategoryService extends Api {
    private apiUrl: string = this.getApiUrl();

    constructor(
        private http: HttpClient,
        // protected appSettings: AppSettingService
    ) {
        super();
    }

    public createCategories(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'categories', params);
    }
    public getCategoriesList(params: any): Observable<any> {
        return this.http.get(this.apiUrl + 'categories', { params });
    }
    public getCategoriesItem(id: number): Observable<any> {
        return this.http.get(this.apiUrl + 'categories' + id);
    }
    public updateCategories(id: number, params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'categories/' + id, params);
    }
    public deleteCategories(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + 'categories/' + id);
    }

    public createSliderItem(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'slideritems', params);
    }
    public getSliderItem(id: number): Observable<any> {
        return this.http.get(this.apiUrl + 'slideritems/' + id);
    }
    public getSliderList(params: any): Observable<any> {
        return this.http.get(this.apiUrl + 'slideritems', params);
    }
    public removeSliderItem(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + 'slideritems/' + id);
    }
    public updateSliderItem(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'slideritems/update', params);
    }

    public createPdfItem(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'pdfs', params);
    }
    public getPdfItem(id: number): Observable<any> {
        return this.http.get(this.apiUrl + 'pdfs/' + id);
    }
    public getPdfList(params: any): Observable<any> {
        return this.http.get(this.apiUrl + 'pdfs', { params: params });
    }
    public removePdfItem(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + 'pdfs/' + id);
    }
    public updatePdfItem(id: number, params: any): Observable<any> {
        return this.http.delete(this.apiUrl + 'pdfs/' + id, params);
    }


    public createSlider(params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'sliders', params);
    }
    public getSlider(id: number): Observable<any> {
        return this.http.get(this.apiUrl + 'sliders/' + id);
    }
    public getSliders(params: any): Observable<any> {
        return this.http.get(this.apiUrl + 'sliders', params);
    }
    public removeSlider(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + 'sliders/delete/' + id);
    }
    public updateSlider(id: number, params: any): Observable<any> {
        return this.http.post(this.apiUrl + 'sliders/update', params);
    }
}